// src/pages/Home.tsx
import React, { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || !user) {
      logout();
      navigate("/login");
    }
  }, [user, logout, navigate]);

  return (
    <div className="max-w-4xl mx-auto mt-8 px-4">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-bold text-gray-800 mb-2">
          Selamat datang, {user?.name || "User"}
        </h1>
        <p className="text-gray-600">Role: {user?.role || "Unknown"}</p>
      </div>
    </div>
  );
};

export default Home;
